import React from 'react';
import { cn } from './cn';

// Dikte aç/kapa butonu — SALT GÖRSEL. Tanıma mantığı lib/useSesliYazdirma.js'te.
// İKON: satır içi SVG. Projede ikon kütüphanesi yok; 🎤 emojisi `currentColor`
// almadığı için "kayıt açık" (beyaz-üstü-kırmızı) durumu emojiyle okunmuyor.
// Ölçü/biçim 1-10 puan butonlarıyla aynı dilde (w-9 h-9 rounded-full border-2).
// Destek yoksa GİZLENMEZ, pasifleşir (DersPills'in "yakında" deseni) — sessiz
// ölü buton öğretmeni "bozuk mu?" diye düşündürür.
export function MikrofonButonu({ dinliyor, destekli, destekMesaji, onTikla, className }) {
  const baslik = !destekli
    ? (destekMesaji || 'Sesli yazdırma kullanılamıyor')
    : dinliyor
      ? 'Dikteyi durdur (Esc veya Ctrl+M)'
      : 'Sesli yazdır — konuşun, yoruma yazılsın (Ctrl+M)';

  return (
    <button
      type="button"
      onClick={onTikla}
      disabled={!destekli}
      aria-pressed={!!dinliyor}
      aria-label={dinliyor ? 'Sesli yazdırmayı durdur' : 'Sesli yazdırmayı başlat'}
      title={baslik}
      className={cn(
        'w-9 h-9 rounded-full border-2 flex items-center justify-center transition-colors',
        !destekli
          ? 'border-dashed border-gray-200 bg-gray-50 text-gray-300 cursor-not-allowed'
          : dinliyor
            ? 'bg-red-500 border-red-600 text-white animate-pulse cursor-pointer'
            : 'bg-white border-gray-300 text-gray-600 hover:border-blue-400 hover:text-blue-600 cursor-pointer',
        className
      )}
    >
      <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
           strokeWidth="2" strokeLinecap="round" aria-hidden="true" focusable="false">
        <rect x="9" y="2" width="6" height="11" rx="3" />
        <path d="M5 11a7 7 0 0 0 14 0" />
        <line x1="12" y1="18" x2="12" y2="22" />
      </svg>
    </button>
  );
}

export default MikrofonButonu;
